import { inject } from '@angular/core';
import { AuthService } from 'app/core/services/auth.service';

export function initializeApp() {
  const authService = inject(AuthService);

  // Firebase Anonymous Sign-In initialization
  return authService.loginFirebase();
}
